export default __webpack_public_path__ + "static/media/link.52a8a7ba.svg";